import { ButtonType } from 'app/copied/models/ChatModules';

const buttonStyles: Record<ButtonType, string> = {
  [ButtonType.Default]: 'rounded-button text-white font-normal text-sm bg-[#1e1e1e] px-5 py-3 disabled:opacity-50',
  [ButtonType.Secondary]: 'faq-button-secondary',
  [ButtonType.Primary]: 'faq-button-primary',
  [ButtonType.Text]: '',
};

export function getButtonClass(buttonType = ButtonType.Default) {
  return buttonStyles[buttonType];
}
